import { createClient } from '@supabase/supabase-js'

const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJyYmRkc25pdnV5aG9ud3pyamljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDEzNTE4ODgsImV4cCI6MjAxNjkyNzg4OH0.u2gOtcLcea_m3NsqA9Dc5qofKIRvnx5U6wfhUIx0-Xs'
const supabaseUrl ="https://brbddsnivuyhonwzrjic.supabase.co"

const supabase = createClient(supabaseUrl, supabaseKey)

export default supabase